import {UseFormReturn} from "react-hook-form";
import {Grid, Stack, Typography} from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import {Frame} from "../base/Frame";
import {LabeledInput} from "../base/LabeledInput";
import {TextInput} from "../base/TextInput";
import {useTranslation} from "react-i18next";

export interface UserPasswordFormInputs {
    currentPassword: string;
    newPassword: string;
    newPasswordRepeat: string;
}

export interface Props {
    initFormValues: UserPasswordFormInputs;
    form: UseFormReturn<UserPasswordFormInputs>;
}

export const UserPasswordForm: React.FC<Props> = ({
    form: {
        register,
        formState: {errors},
    },
}) => {
    const {t} = useTranslation();

    return (
        <Frame>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <LabeledInput label={t("users.password_form.current_password")}>
                                <TextInput
                                    name="currentPassword"
                                    type="password"
                                    register={register}
                                    errors={errors}
                                    inputProps={{autoComplete: "current-password"}}
                                />
                            </LabeledInput>
                        </Grid>
                        <Grid item xs={12}>
                            <LabeledInput label={t("users.password_form.new_password")}>
                                <TextInput
                                    name="newPassword"
                                    type="password"
                                    register={register}
                                    errors={errors}
                                    inputProps={{autoComplete: "new-password"}}
                                />
                            </LabeledInput>
                        </Grid>
                        <Grid item xs={12}>
                            <LabeledInput label={t("users.password_form.repeat_password")}>
                                <TextInput
                                    name="newPasswordRepeat"
                                    type="password"
                                    register={register}
                                    errors={errors}
                                />
                            </LabeledInput>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6} sx={{marginTop: "1.5rem"}}>
                    <Stack direction="row" gap={1}>
                        <InfoIcon fontSize="small" color="primary" />
                        <Typography fontSize={14}>{t("users.password_form.content")}</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Frame>
    );
};
